import React, { FC, useEffect } from 'react';
import ModalWrap, { ModalWrapType } from '../../../../components/ModalWrap';
import { useIntl } from 'react-intl';
import { OptionModal } from '..';
import { Col, Form, Row, Switch } from 'antd';
import { CreateOptionDto, UpdateOptionDto } from '../../../../apis/client-axios';
import InputWrap from '../../../../components/InputWrap';

interface UpsertOptionModalProps {
  loading: boolean;
  optionModal: OptionModal;
  onSubmit: (values: CreateOptionDto | UpdateOptionDto) => void;
  onCancel: () => void;
}

const n = (key: keyof CreateOptionDto) => key;

const UpsertOptionModal: FC<UpsertOptionModalProps> = (props) => {
  const { loading, optionModal, onSubmit, onCancel } = props;

  const intl = useIntl();
  const [form] = Form.useForm<CreateOptionDto | UpdateOptionDto>();

  useEffect(() => {
    if (optionModal?.option?.id) {
      form.setFieldsValue({
        [n('title')]: optionModal?.option?.title,
        [n('status')]: optionModal?.option?.status,
        [n('isRequireAdditionalDetail')]: optionModal?.option?.isRequireAdditionalDetail,
        [n('isSendLineMessage')]: optionModal?.option?.isSendLineMessage,
      });
    }
  }, [optionModal?.option]);

  return (
    <>
      <ModalWrap
        open={optionModal.type === 'upsert'}
        onSubmit={() => onSubmit(form.getFieldsValue())}
        onCancel={onCancel}
        title={intl.formatMessage({ id: !optionModal.option?.id ? 'choiceSettings.addNew' : 'choiceSettings.edit' })}
        cancelText={intl.formatMessage({ id: 'common.cancel' })}
        submitText={intl.formatMessage({ id: !optionModal.option?.id ? 'choiceSettings.add' : 'common.save' })}
        type={optionModal.type as ModalWrapType}
        buttonSubmitProps={{ disabled: loading }}
        body={
          <Form form={form} layout="inline" requiredMark={false} colon={false}>
            <Row gutter={[32, 24]}>
              <Col span={24}>
                <Form.Item
                  name={n('title')}
                  className="mb-0"
                  label={<span className="fw-semibold">{intl.formatMessage({ id: 'choiceSettings.choice' })}</span>}
                  layout="vertical"
                  rules={[
                    { required: true, message: intl.formatMessage({ id: 'common.required' }) },
                    {
                      whitespace: true,
                      message: intl.formatMessage({ id: 'common.required' }),
                    },
                  ]}
                >
                  <InputWrap
                    maxLength={255}
                    className="width-full"
                    placeholder={intl.formatMessage({ id: 'choiceSettings.enterYourChoicesAdd' })}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item
                  name={n('status')}
                  className="mb-0"
                  label={
                    <span className="fw-semibold">{intl.formatMessage({ id: 'choiceSettings.availability' })}</span>
                  }
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item
                  name={n('isRequireAdditionalDetail')}
                  className="mb-0"
                  label={<span className="fw-semibold">{intl.formatMessage({ id: 'common.inputDisplay' })}</span>}
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item
                  name={n('isSendLineMessage')}
                  className="mb-0"
                  label={<span className="fw-semibold">{intl.formatMessage({ id: 'common.sendLineMessage' })}</span>}
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        }
      />
    </>
  );
};

export default UpsertOptionModal;
